module.exports = __webpack_public_path__ + "6ba8844a.png";